

const dashboardNASDAQChart = {
  data: (canvas) => {
    return {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          data: [
             sessionStorage.getItem('January')==null ? '0' :sessionStorage.getItem('January')
            ,sessionStorage.getItem('February')==null ? '0' :sessionStorage.getItem('February')
            ,sessionStorage.getItem('March')==null ? '0' :sessionStorage.getItem('March')
            ,sessionStorage.getItem('April')==null ? '0' :sessionStorage.getItem('April')
            ,sessionStorage.getItem('May')==null ? '0' :sessionStorage.getItem('May')
            ,sessionStorage.getItem('June')==null ? '0' :sessionStorage.getItem('June')
            ,sessionStorage.getItem('July')==null ? '0' :sessionStorage.getItem('July')
            ,sessionStorage.getItem('August')==null ? '0' :sessionStorage.getItem('August')
            ,sessionStorage.getItem('September')==null ? '0' :sessionStorage.getItem('September')
            ,sessionStorage.getItem('October')==null ? '0' :sessionStorage.getItem('October')
            ,sessionStorage.getItem('November')==null ? '0' :sessionStorage.getItem('November')
            ,sessionStorage.getItem('December')==null ? '0' :sessionStorage.getItem('December')
           
          ],
          fill: false,
          borderColor: "#fbc658",
          backgroundColor: "transparent",
          pointBorderColor: "#fbc658",
          pointRadius: 4,
          pointHoverRadius: 4,
          pointBorderWidth: 8,
          tension: 0.4,
        },
      
      ],
    };
  },
  options: {
    plugins: {
      legend: { display: false },
      
    },
  },
};

module.exports = {
  
  dashboardNASDAQChart,
};
